import React from "react";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { cn } from "@/lib/utils";
import LogoSvg from "./LogoSvg";

const footerLinks = [
  { name: "Terms of Service", path: "/terms" },
  { name: "Privacy Policy", path: "/privacy" },
  { name: "Fulfillment", path: "/fulfillment" },
  { name: "Cookie Policy", path: "/cookies" },
  { name: "Information Security", path: "/security" },
  {
    name: "Careers",
    path: "https://app.dover.com/dover/careers/55804ec3-5e7e-4a43-9004-68efe17cc688",
  },
];

const socialLinks = [
  {
    name: "LinkedIn",
    icon: () => (
      <Linkedin
        size={18}
        className="text-muted-foreground hover:text-primary transition-colors"
      />
    ),
    url: "https://www.linkedin.com/company/openpipe",
  },
];

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  return (
    <section className={cn("w-full bg-background py-6", className)}>
      <div className="container mx-auto px-4">
        <div className="flex flex-row justify-center items-center mb-8 space-x-6">
          <LogoSvg className="h-8" />
          <div className="flex items-center space-x-6">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="sidebar-nav-link"
                aria-label={link.name}
              >
                {link.icon()}
              </a>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap gap-x-6 gap-y-3 text-sm justify-center mb-6">
          {footerLinks.map((link) => (
            <Link
              key={link.name}
              to={link.name === "Careers" ? link.path : link.path}
              className="sidebar-nav-link"
              {...(link.name === "Careers"
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
            >
              <span className="sidebar-text">{link.name}</span>
            </Link>
          ))}
        </div>

        <div>
          <p className="text-center text-xs text-muted-foreground mt-4">
            © {new Date().getFullYear()} OpenPipe Inc. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
